import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { EntraIdService } from '../../service';

export type RoleMembershipLogsConfig = typeof RoleMembershipLogsConfig._.Config;

export const RoleMembershipLogsConfig = IntegrationConfig.make({
  service: EntraIdService,
  name: Integration_Handler_Names_Enum.RoleMembershipLogs,
  configSchema: z.object({
    roleNamePatternFilter: patternFilterSchema.optional(),
    maxLogAgeInDays: z.number().int().positive().optional(),
    failOnUserAddition: z.boolean().optional(),
  }),
});
